import { BankAccount as ApiBankAccount } from '@vendasta/billing';

export interface BankAccount {
  id: string;
  accountHolderName: string;
  bankName: string;
  country: string;
  currency: string;
  routingNumber: string;
  last4: string;
  defaultForCurrency: boolean;
}

export function bankAccountFromApi(r: ApiBankAccount): BankAccount {
  return {
    id: r.id,
    accountHolderName: r.accountHolderName,
    bankName: r.bankName,
    country: r.country,
    currency: r.currency,
    routingNumber: r.routingNumber,
    last4: r.last4,
    defaultForCurrency: r.defaultForCurrency,
  } as BankAccount;
}
